module.exports = __webpack_public_path__ + "img/chronos_wheel.0cc53512.png";